import { ControlledSelect } from '../../components/ControlledSelect'
import { ChakraStylesConfig, GroupBase, OptionsOrGroups } from 'chakra-react-select'

export interface InsuredFieldsProps {
  options?: OptionsOrGroups<any, GroupBase<unknown>> | undefined
  isLoading?: boolean
}

export const InsuredFields = ({ options, isLoading = false, ...rest }: InsuredFieldsProps) => {
  const chakraStyles: ChakraStylesConfig = {
    container: (provided) => ({
      ...provided,
      width: '100%',
    }),
    inputContainer: (provided) => ({
      ...provided,
      width: '100%',
    }),
    input: (provided) => ({
      ...provided,
      width: '100%',
    }),
  }

  return (
    <ControlledSelect
      label="Obory podnikání"
      name="insuredFields"
      options={options}
      isMulti
      placeholder="Vyberte..."
      noOptionsMessage={() => 'Žádné možnosti'}
      chakraStyles={chakraStyles}
      isLoading={isLoading}
      {...rest}
    />
  )
}
